<div class="page-content">
  <!-- Header Section -->
  <div class="page-title-container">
    <div class="breadcrumb-spacer"></div>
    <h1 class="page-title">App Settings</h1>
  </div>

  <div class="app-settings-container">
    <!-- Search Section -->
    <mat-card class="filters-card">
      <mat-card-content>
        <form [formGroup]="searchForm" class="filters-form">
          <div class="filter-row">
            <!-- Search Field -->
            <mat-form-field appearance="outline" class="search-field">
              <mat-label>Search settings</mat-label>
              <input
                matInput
                [(ngModel)]="searchQuery"
                [ngModelOptions]="{ standalone: true }"
                placeholder="Search by key, value, description, or type..."
                autocomplete="off"
                (input)="onSearchInput()"
                />
              <mat-icon
                matSuffix
                [style.cursor]="searchQuery ? 'pointer' : 'default'"
                (click)="clearSearch()"
                >{{ searchQuery ? "close" : "search" }}</mat-icon
                >
              </mat-form-field>
            </div>
          </form>
        </mat-card-content>
      </mat-card>

      <!-- Loading State -->
      @if (isLoading) {
        <div class="loading-container">
          <mat-spinner diameter="40"></mat-spinner>
          <span>Loading app settings...</span>
        </div>
      }

      <!-- Error State -->
      @if (error && !isLoading) {
        <app-error-state
          [message]="error"
          (retry)="retryLoad()"
        ></app-error-state>
      }

      <!-- Settings Table -->
      @if (!isLoading && !error) {
        <mat-card class="table-card no-padding">
          <mat-card-content>
            <div class="table-container">
              <table
                mat-table
                [dataSource]="dataSource"
                matSort
                (matSortChange)="sortSettings($event)"
                class="settings-table"
                >
                <!-- Data Type Column -->
                <ng-container matColumnDef="dataType">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    class="type-column"
                    >
                    Type
                  </th>
                  <td mat-cell *matCellDef="let setting">
                    <mat-chip
                      class="data-type-chip"
                      [class]="getDataTypeBadgeColor(setting.dataType)"
                      >
                      {{ setting.dataType }}
                    </mat-chip>
                  </td>
                </ng-container>

                <!-- Key Column (with Description) -->
                <ng-container matColumnDef="key">
                  <th
                    mat-header-cell
                    *matHeaderCellDef
                    mat-sort-header
                    class="key-column"
                    >
                    Configuration Key
                  </th>
                  <td mat-cell *matCellDef="let setting" class="key-cell">
                    <div class="key-content">
                      <span class="key-text">{{ setting.key }}</span>
                      @if (setting.description) {
                        <span
                          class="description-text"
                          >{{ setting.description }}</span
                          >
                        }
                      </div>
                    </td>
                  </ng-container>

                  <!-- Value Column -->
                  <ng-container matColumnDef="value">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Value</th>
                    <td mat-cell *matCellDef="let setting">
                      <span class="value-text">{{ setting.value }}</span>
                    </td>
                  </ng-container>

                  <!-- Status Column -->
                  <ng-container matColumnDef="isActive">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      mat-sort-header
                      class="status-column"
                      >
                      Status
                    </th>
                    <td mat-cell *matCellDef="let setting">
                      <mat-chip
                    [class]="
                      setting.isActive ? 'status-active' : 'status-inactive'
                    "
                        >
                        {{ setting.isActive ? "Active" : "Inactive" }}
                      </mat-chip>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                    (click)="onSettingClick(row)"
                    [class.clickable]="canEditSettings"
                  ></tr>

                  <!-- Empty State -->
                  <tr class="mat-row" *matNoDataRow>
                    <td
                      class="mat-cell no-data-cell"
                      [attr.colspan]="displayedColumns.length"
                      >
                      <div class="empty-state">
                        <mat-icon>search_off</mat-icon>
                        <span>No settings found matching your search</span>
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </mat-card-content>
          </mat-card>
        }
      </div>
    </div>
